import { FiExternalLink, FiFile } from "react-icons/fi";

export default function ExpenseReceiptLinks({ receipts }) {
  if (!receipts?.length) {
    return <p className="text-sm text-base-content/50">No receipts attached.</p>;
  }

  return (
    <ul className="space-y-2">
      {receipts.map((receipt) => (
        <li key={receipt.id}>
          <a
            href={receipt.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between gap-3 rounded-lg border border-base-200 bg-base-100 px-3 py-2.5 text-sm transition hover:border-primary/40 hover:bg-primary/5"
          >
            <span className="flex min-w-0 items-center gap-2 font-medium text-primary">
              <FiFile className="h-4 w-4 shrink-0" aria-hidden />
              <span className="truncate">{receipt.name}</span>
            </span>
            <FiExternalLink className="h-4 w-4 shrink-0 text-base-content/45" aria-hidden />
          </a>
        </li>
      ))}
    </ul>
  );
}
